<template>
  <div id="prefix_banner">
    <p class="desc">茂名高新区国家级科技企业孵化器由茂名高新技术创业服务中心运营，拥有孵化面积1.3万㎡，配套人才公寓、企业服务中心、培训室、会议室、咖啡厅、餐厅等，提供科技金融、知识产权、会计法务、人力资源平台服务。</p>
    <swiper :options="swiperOption" :not-next-tick="notNextTick" ref="mySwiper">
      <!-- slides -->
      <swiper-slide>
        <div class="banner_img"  v-bind:style="{'background': 'url('+require('../assets/images/prefixBanner/bg.jpg')+')',backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover' }">
          <img class="bg_text" src="../assets/images/prefixBanner/bg_text.png" alt="">
          <img class="xia003" src="../assets/images/prefixBanner/xia003.png" alt="">
          <img class="you002" src="../assets/images/prefixBanner/you002.png" alt="">
          <img class="zuo001" src="../assets/images/prefixBanner/zuo001.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide v-for="item in prefixBannerList" :key="item.id">
        <div class="banner_img" v-bind:style="{'background': 'url('+item.link+')',backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover' }">
          <!--<p class="title">高新区国家孵化园</p>-->
        </div>
      </swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-pagination" slot="pagination" v-show="show"></div>
      <div class="swiper-button-prev" slot="button-prev" v-show="show"></div>
      <div class="swiper-button-next" slot="button-next" v-show="show"></div>
    </swiper>
    <img class="logo_img" src="../assets/images/index/logo.png" alt="茂名高新区国家级科技企业孵化器">
    <img class="login_img" src='../assets/images/prefixBanner/down.png' alt="">
    <span class="login" @click="loginIndex()"> 进入首页 </span>
  </div>
</template>

<script>
  import {swiper, swiperSlide} from 'vue-awesome-swiper';
  import 'swiper/dist/css/swiper.css'
  import loginImg from '../assets/images/prefixBanner/down.png'
  import {queryPrefixBanner} from '@/api/PrefixBanner.js'

  export default {
    components: {
      swiper,
      swiperSlide
    },
    name: 'PrefixBanner',
    data() {
      return {
        loginImg: loginImg,
        prefixBannerList: [],
        notNextTick: false,
        show: false,
        swiperOption: {
          //autoplay: 4000,
          direction: 'horizontal',
          grabCursor: true,
          setWrapperSize: true,
          autoHeight: true,
          pagination: '.swiper-pagination',
          paginationClickable: true,
          prevButton: '.swiper-button-prev',
          nextButton: '.swiper-button-next',
          //scrollbar: '.swiper-scrollbar',
          mousewheelControl: true,
          observeParents: true,
        }
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    mounted() {

    },
    created() {
      this.getPrefixBanner()
    },
    methods: {
      loginIndex() {
        this.$router.push('/index')
      },
      getPrefixBanner() {
        queryPrefixBanner().then((res) => {
          this.prefixBannerList = res
          if (this.prefixBannerList.length > 0) {
            this.show = true
          }else {
            this.show = false
          }
        })
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  /*覆盖swiper样式*/
  .swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    right: 90px;
    background-image: url("../assets/images/prefixBanner/next.png")
  }

  .swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    left: 90px;
    background-image: url("../assets/images/prefixBanner/pre.png")
  }

  .swiper-button-prev, .swiper-button-next {
    width: 70px;
    height: 70px;
    background-size: 70px 70px;
  }

  .swiper-slide, .swiper-slide .swiper-slide-active {
    width: 100%;
    height: 100%;
  }

  #prefix_banner {
    width: 100%;
    min-width: 800px;
    height: 100%;
    position: relative;
    .swiper-container {
      height: 100%;
    }
    .banner_img {
      width: 100%;
      height: 100%;
      position: relative;
      .title {
        width: 450px;
        line-height: 68px;
        position: absolute;
        left: 50%;
        top: 48%;
        margin-left: -225px;
        font-size: 52px;
        color: #fff;
        text-align: center;
      }
      .bg_text{
        position: absolute;
        left:21.25%;
        top: 31.29%;
        width: 55.88%;
        animation:zoomIn 2s .8s both 1;
      }
      .zuo001{
        position: absolute;
        width: 31.09%;
        left: 15.97%;
        top: 21%;
      }
      .you002{
        position: absolute;
        width: 19.375%;
        right: 16.04%;
        top: 20.22%;
      }
      .xia003{
        position: absolute;
        width: 31.25%;
        right: 28.25%;
        bottom: 0;
      }
    }
    .logo_img {
      width: 31.25%;
      height: auto;
      position: absolute;
      top: 6%;
      left: 18%;
      z-index: 2;
    }
    .login_img {
      width: 43px;
      height: 40px;
      position: absolute;
      left: 50%;
      bottom: 20%;
      margin-left: -21px;
      z-index: 2;
      animation: loginAnimation 1.5s linear infinite;
    }
    @keyframes loginAnimation {
      0% {
        transform: translateY(0%);
        opacity: 0.6;
      }
      50%{
        transform: translateY(-20%);
        opacity: 1;
      }
      100%{
        transform: translateY(0);
        opacity: 0.6;
      }
    }
    .login {
      width: 148px;
      height: 51px;
      position: absolute;
      left: 50%;
      bottom: 10%;
      margin-left: -74px;
      font-size: 20px;
      color: #fff;
      background-color: $themeColor;
      border-radius: 5px;
      text-align: center;
      line-height: 51px;
      z-index: 2;
      cursor: pointer;
    }
    .login:hover {
      background-color: #fff;
      color: $themeColor;
      transition: background-color 0.3s linear;
    }
    .desc{
      opacity: 0;
      position: fixed;
      top: 0;
      z-index: -99;
    }
  }
</style>
